function scrollReveal(){

  let smallerOffset = window.ww < 660 ? true : false
  let smallerOffsetPercent = false
  if (window.isBasic) {
    smallerOffsetPercent = true
  }

  $('[data-reveal]').each(function(){
    let $self = $(this)

    if ($self.hasClass('js-reveal-watching')) return
    $self.addClass('js-reveal-watching')// prevent spam

    let onViewport = false
    $self[0].revealed = false


    let startX
    let endX
    let startY
    let endY

    let mode = $self.attr('data-reveal-scroll') ? $self.attr('data-reveal-scroll') : 'auto'

    function reveal(){
      if (window.preventScrollReveal) return
      if ($self[0].revealed) return
      $self[0].revealed = true
      anim.scrollReveal($self)
    }

    let willUpdate = _.debounce(getCoords, 100)

    function returnSize(value, size){
      let number = parseInt(value)



      if (!isNaN(value)) {
        return number
      } else if (value.indexOf('%') >= 0){
        return number / 100 * -size
      } else if (value.indexOf('vw') >= 0){
        return number / 100 * -ww
      } else if (value.indexOf('vh') >= 0){
        return number / 100 * -wh
      } else {
        return number
      }
    }

    function getCoords(){
      // y stuff
      let posY = Math.round($self.offset().top)


      if (!sniffer.isSimplified && window.scrollType === 'virtual') {
        if (mode === 'auto') {
          posY += Math.round(st.easedReal)
        } else {
          // CODE CUSTOM
          posY += Math.round(stbis.easedReal)
        }
      }


      const height = $self.outerHeight()
      let offsetY = $self.attr('data-reveal-offset') ? $self.attr('data-reveal-offset') : 0

      if (typeof offsetY === 'string' && offsetY.indexOf('%') >= 0) {
        offsetY = parseFloat(offsetY) / 100 * wh
        if (smallerOffsetPercent) {
          offsetY = 0
        }
      }

      if (offsetY) offsetY = returnSize(offsetY, height)
      const decalY = smallerOffset ? offsetY/2 : offsetY
      startY = Math.round(posY + decalY - wh)
      endY = Math.round(posY - decalY + height)

      // x stuff
      let posX = Math.round($self.offset().left)
      if ( (!sniffer.isSimplified && window.scrollType === 'virtual')
        || (!sniffer.isSimplified && window.scrollType === 'smooth')) posX += Math.round(stx.easedReal) ? Math.round(stx.easedReal) : 0
      const width = $self.outerWidth()
      let offsetX = $self.attr('data-reveal-offset-x') ? $self.attr('data-reveal-offset-x') : 0
      if (offsetX) offsetX = returnSize(offsetX, width)
      const decalX = smallerOffset ? offsetX/2 : offsetX
      startX = Math.round(posX + decalX - ww)
      endX = Math.round(posX - decalX + width)
    }


    const debounceReveal = _.throttle(seekReveal, 1000/10)
    function seekReveal(){
      let isItOnViewportX = stx.easedReal >= startX && stx.easedReal <= endX
      let isItOnViewportY = st.easedReal > startY && st.easedReal < endY

      if (mode !== 'auto') {
        isItOnViewportY = stbis.easedReal > startY && stbis.easedReal < endY
      }

      onViewport = isItOnViewportY && isItOnViewportX

      $self.toggleClass('js-onviewport', onViewport)

      if (window.preventScrollReveal) return
      if ($self[0].revealed) return

      if (onViewport) {
        $self[0].revealed = true
        anim.scrollReveal($self)
      }
    }


    function checkScrollReveal(){
      seekReveal()
    }

    function eventOn(){
      bus.on('pageLeaveEnd', eventOff)
      bus.on('checkScrollReveal', checkScrollReveal)

      bus.on('resize', willUpdate)
      bus.on('resizeContainer', willUpdate)
      bus.on('revealRefresh', getCoords)
      bus.on('scrollupdate', debounceReveal)
    }
    function eventOff(){
      bus.off('pageLeaveEnd', eventOff)
      bus.off('checkScrollReveal', checkScrollReveal)

      bus.off('resize', willUpdate)
      bus.off('resizeContainer', willUpdate)
      bus.off('revealRefresh', getCoords)
      bus.off('scrollupdate', debounceReveal)
    }
    getCoords()
    eventOn()
  })

}
export default scrollReveal